<template>
  <div class="sifa-cont-right">
    <div class="personbox">
      <h2>结算款管理</h2>
      <div class="sub-page"></div>
      <template>
        <el-table :cell-style="{textAlign:'center'}" :data="data" :header-cell-style="{textAlign: 'center'}"
                  style="width: 100%">
          <el-table-column label="拍卖会名称" prop="meetingName" width="120"></el-table-column>
          <el-table-column label="代收成交款总额(元)" prop="totalBidPrice"></el-table-column>
          <el-table-column label="代收评估费总金额(元)" prop="totalEvaluationFee"></el-table-column>
          <el-table-column label="过户(移交)保证金总额(元)" prop="totalHandoverDeposit"></el-table-column>
          <el-table-column label="佣金总金额(元)" prop="totalCommission"></el-table-column>
          <el-table-column label="实缴金额(元)" prop="totalFinalPayment"></el-table-column>
          <el-table-column label="已缴金额(元)" prop="totalPaidMoney"></el-table-column>
          <el-table-column align="center" label="待缴金额(元)" prop="totalUnpaidMoney" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.totalUnpaidMoney < 0" style="color: green;">
                 结余 {{ Math.abs(scope.row.totalUnpaidMoney) }}
              </span>
              <span v-else-if="scope.row.totalUnpaidMoney > 0" style="color: red;">
                  {{ scope.row.totalUnpaidMoney }}
               </span>
              <span v-else>{{ scope.row.totalUnpaidMoney }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="退款金额(元)" prop="refundAmount" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.refundAuditStatus === 30">{{ scope.row.refundAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="退款状态" prop="backState">
            <template slot-scope="scope">
              <el-button v-if="scope.row.refundAuditStatus === 30" size="small" type="text"
                         @click="viewRefundStatus(scope.row)">
                查看退款状态
              </el-button>
              <span v-else>{{ scope.row.backState }}</span>
            </template>
          </el-table-column>
          <el-table-column
              fixed="right"
              label="操作"
              width="120">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="view(scope.row)">查看结算单</el-button>
              <el-button v-if="scope.row.auditStatus == 10 " size="small"
                         type="text" @click="pay(scope.row)"
              >缴纳结算款
              </el-button>
              <el-button v-if="scope.row.auditStatus == 99 " size="small"
                         type="text" @click="pay(scope.row)"
              >重新缴纳结算款
              </el-button>
              <el-button v-if="scope.row.auditStatus == 20 || scope.row.auditStatus == 30" size="small" type="text"
                         @click="viewPay(scope.row)">查看缴纳结算款
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <div class="block">
        <el-pagination
            :current-page="page.currentPage"
            :page-size="page.pageSize"
            :page-sizes="[10,20,30,40,50,100]"
            :total="page.total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
        </el-pagination>
      </div>
      <!-- 查看结算单 -->
      <el-dialog
          :title="dialogTitle"
          :visible.sync="dialogVisible"
          append-to-body
          top="5vh"
          width="80%"
          @close="handleDialogClose"
      >
        <el-form :model="settlementForm" label-width="160px" size="small">
          <el-divider content-position="left">拍卖会信息</el-divider>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="拍卖会名称" prop="meetingName">
                <el-input v-model="settlementForm.meetingName" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-divider content-position="left">项目信息列表</el-divider>
          <el-collapse v-model="activeNames">
            <el-collapse-item
                v-for="(project, projectIndex) in settlementForm.projects"
                :key="projectIndex"
                :name="projectIndex"
                :title="project.projectName"
            >
              <div style="padding-left: 20px;">
                <el-table
                    :data="[project]"
                    border
                    size="mini" style="width: 100%; margin-bottom: 15px;"
                >
                  <el-table-column align="center" label="项目编号" prop="projectCode" width="240"></el-table-column>
                  <el-table-column align="center" label="项目名称" prop="projectName" width="450"></el-table-column>
                  <el-table-column align="center" label="是否代收成交款" width="150">
                    <template slot-scope="scope">
                      {{ scope.row.isCollect ? '是' : '否' }}
                    </template>
                  </el-table-column>
                </el-table>

                <el-divider content-position="left">标的详细信息</el-divider>
                <el-table
                    :data="project.auctionLots"
                    border
                    size="mini" style="width: 100%; margin-bottom: 15px;"
                >
                  <el-table-column align="center" label="标的名称" prop="lotName" width="120"></el-table-column>
                  <el-table-column align="center" label="标的保证金金额(元)" prop="depositePrice" width="100">
                    <template slot-scope="scope">
                      {{ scope.row.depositePrice }}
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="成交款金额(元)" prop="currentQuoted" width="100">
                    <template slot-scope="scope">
                      {{ scope.row.currentQuoted }}{{ getPriceUnit(scope.row) }}
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="是否代收评估费" prop="isEvaluationFee" width="100">
                    <template slot-scope="scope">
                      {{ scope.row.isEvaluationFee ? '是' : '否' }}
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="评估费缴纳方" prop="evaluationFeePayer" width="120">
                    <template slot-scope="scope">
                      {{
                        scope.row.evaluationFeePayer === 1 ? '委托人' : (scope.row.evaluationFeePayer === 2 ? '买受人' : '')
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="代收评估费(元)" prop="evaluationFee" width="100">
                    <template slot-scope="scope">
                      {{ scope.row.evaluationFee }}
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="过户(移交)保证金(元)" prop="handoverDeposit" width="100">
                    <template slot-scope="scope">
                      {{ scope.row.handoverDeposit }}
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="佣金收取方式" prop="comType" width="100">
                    <template slot-scope="scope">
                      {{ formatComType(scope.row.comType) }}
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="佣金比例(%)" prop="fromRatio" width="100">
                    <template slot-scope="scope">
                      {{ scope.row.fromRatio }}
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="佣金金额(元)" prop="commission" width="100">
                    <template slot-scope="scope">
                      {{ scope.row.commission }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
          </el-collapse>
          <el-divider content-position="left">结算汇总</el-divider>
          <el-table :data="settlementSummary" border size="small" style="width: 100%; margin-bottom: 20px;">
            <el-table-column align="center" label="费用名称" prop="name" width="300"></el-table-column>
            <el-table-column align="center" label="金额(元)" prop="value">
              <template slot-scope="scope">
               <span
                   v-if="scope.row.name === '待缴金额' && scope.row.isNegative !== undefined"
                   :class="scope.row.isNegative ? 'amount-negative' : 'amount-positive'"
               >
                 {{ scope.row.displayValue }}
                </span>
                <span v-else>{{ scope.row.value }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog
          :visible.sync="payDialog"
          center
          class="custom-dialog"
          title="您的缴费信息"
          width="50%">
        <el-form :model="settlementForm" label-width="160px" size="small">
          <el-divider content-position="left">结算汇总</el-divider>
          <el-table :data="settlementSummary" border size="small" style="width: 100%; margin-bottom: 20px;">
            <el-table-column align="center" label="费用名称" prop="name" width="200"></el-table-column>
            <el-table-column align="center" label="金额(元)" prop="value">
              <template slot-scope="scope">
             <span
                 v-if="scope.row.name === '待缴金额' && scope.row.isNegative !== undefined"
                 :class="scope.row.isNegative ? 'amount-negative' : 'amount-positive'"
             >
            {{ scope.row.displayValue }}
           </span>
                <span v-else>{{ scope.row.value }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <div v-if="auditStatus == 99">
          <el-divider content-position="left">已提交缴费信息</el-divider>
        </div>
        <div v-if="auditStatus == 99" class="custom-button-wrapper">
          <el-table :data="settlementForm.payInfos" border size="small" style="width: 100%">
            <el-table-column align="center" label="序号" type="index" width="80"></el-table-column>
            <el-table-column align="center" label="交易流水号" prop="busino"></el-table-column>
            <el-table-column align="center" label="付款人账号" prop="payAccount"></el-table-column>
            <el-table-column align="center" label="付款人名称" prop="genterName"></el-table-column>
            <el-table-column align="center" label="收款账号" prop="genterAccount"></el-table-column>
            <el-table-column align="center" label="到账金额" prop="payAmount"></el-table-column>
            <el-table-column align="center" label="到账时间" prop="accountTime"></el-table-column>
          </el-table>
        </div>
        <!-- 线上支付 -->
        <div v-if="payType === 1" style="padding-top: 10px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form :model="bankInfo" disabled label-width="100px" size="small">
                <el-form-item label="收款账号:">
                  <el-input v-model="meetingDetail.depositPayAccount" :style="{ width: '200px' }"></el-input>
                </el-form-item>
                <el-form-item label="收款户名:">
                  <el-input v-model="bankInfo.accountName" :style="{ width: '200px' }"></el-input>
                </el-form-item>
                <el-form-item label="开户行:">
                  <el-input v-model="bankInfo.bankName" :style="{ width: '200px' }"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form :model="companyInfo" label-width="100px" size="small">
                <el-form-item label="您的实际付款账号:">
                  <el-input v-model="companyInfo.bankAccount" :style="{ width: '200px' }"></el-input>
                </el-form-item>
              </el-form>
              <div style="margin-top: 20px;">
                <el-button size="small" style="width: 30%;" type="primary" @click="getCommissionRecords">
                  获取缴费记录
                </el-button>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-table :data="tableData" border height="250" size="small" style="width: 100%">
              <el-table-column align="center" label="序号" type="index" width="80"></el-table-column>
              <el-table-column align="center" label="交易流水号" prop="busino"></el-table-column>
              <el-table-column align="center" label="付款人账号" prop="payAccount"></el-table-column>
              <el-table-column align="center" label="付款人名称" prop="genterName"></el-table-column>
              <el-table-column align="center" label="收款账号" prop="genterAccount"></el-table-column>
              <el-table-column align="center" label="到账金额" prop="payAmount"></el-table-column>
              <el-table-column align="center" label="到账时间" prop="accountTime"></el-table-column>
              <el-table-column align="center" label="支付类别" prop="payCategory">
                <template slot-scope="scope">
                  {{ formatPayCategory(scope.row.payCategory) }}
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </div>
        <!-- 线下支付 -->
        <div v-if="payType == 2" class="upload-container">
          <el-form :model="bankInfo" label-width="200px" size="small">
            <el-form-item :rules="[{ required: true, message: '请输入您实际缴纳结算款金额', trigger: 'blur' }]"
                          label="实际缴纳结算款金额(元):"
                          prop="payAmount">
              <el-input v-model="bankInfo.payAmount" :style="{ width: '300px' }"></el-input>
            </el-form-item>

            <el-upload :action="`/api/sino-resource/oss/endpoint/put-file?${this.website.tokenHeader}=${this.token}`"
                       :before-upload="beforeUpload" :limit="1"
                       :on-preview="uploadPreview"
                       :on-remove="comFileRemove"
                       :on-success="handleCommissionSuccess"
                       class="upload-demo"
                       drag
                       multiple
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div slot="tip" class="el-upload__tip">请上传缴费凭证附件</div>
            </el-upload>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
                    <el-button size="small" style="width: 15%;" type="primary"
                               @click="submitRecords(payType)">提 交</el-button>
                </span>
      </el-dialog>

      <el-dialog
          :on-preview="uploadPreview"
          :visible.sync="viewDialog"
          center
          class="custom-dialog"
          title="查看缴费信息"
          width="50%">
        <el-form :model="settlementForm" label-width="160px" size="small">
          <el-divider content-position="left">结算汇总</el-divider>
          <el-table :data="settlementSummary" border size="small" style="width: 100%; margin-bottom: 20px;">
            <el-table-column align="center" label="费用名称" prop="name" width="200"></el-table-column>
            <el-table-column align="center" label="金额(元)" prop="value">
              <template slot-scope="scope">
             <span
                 v-if="scope.row.name === '待缴金额' && scope.row.isNegative !== undefined"
                 :class="scope.row.isNegative ? 'amount-negative' : 'amount-positive'"
             >
            {{ scope.row.displayValue }}
           </span>
                <span v-else>{{ scope.row.value }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <!-- 线上支付 -->
        <div>
          <el-row>
            <el-table :data="tableData" border height="250" size="small" style="width: 100%">
              <el-table-column align="center" label="序号" type="index" width="80"></el-table-column>
              <el-table-column align="center" label="交易流水号" prop="busino"></el-table-column>
              <el-table-column align="center" label="付款人账号" prop="payAccount"></el-table-column>
              <el-table-column align="center" label="收款银行名称" prop="genterName"></el-table-column>
              <el-table-column align="center" label="收款账号" prop="genterAccount"></el-table-column>
              <el-table-column align="center" label="到账金额" prop="payAmount"></el-table-column>
              <el-table-column align="center" label="到账时间" prop="accountTime"></el-table-column>
              <el-table-column align="center" label="支付类别" prop="payCategory">
                <template slot-scope="scope">
                  {{ formatPayCategory(scope.row.payCategory) }}
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </div>
        <!-- 线下支付 -->
        <!--        <div v-if="payType == 2" class="upload-container">

                  <el-upload :action="`/api/sino-resource/oss/endpoint/put-file?${this.website.tokenHeader}=${this.token}`"
                             :before-upload="beforeUpload" :disabled="true"
                             :file-list="commissionList"
                             :limit="1"
                             :on-preview="previewCommissionFile"
                             :on-remove="comFileRemove"
                             :on-success="handleCommissionSuccess"
                             class="upload-demo"
                             drag
                             multiple
                  >
                    <i class="el-icon-upload"></i>
                    <div slot="tip" class="el-upload__tip">缴费凭证附件</div>
                  </el-upload>
                </div>-->
      </el-dialog>
      <!-- 退款状态详情 -->
      <el-dialog
          :title="refundDialogTitle"
          :visible.sync="refundDialog"
          append-to-body
          width="60%"
      >
        <el-table :data="refundStatusData" border style="width: 100%">
          <el-table-column align="center" label="收款账号">
            <template slot-scope="scope">
              {{ scope.row.crtAcc }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="户名">
            <template slot-scope="scope">
              {{ scope.row.crtNam }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="退款状态">
            <template slot-scope="scope">
              {{ scope.row.reqSts }}
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
    <el-button size="small" @click="refundDialog = false">关 闭</el-button>
  </span>
      </el-dialog>
    </div>
    <el-dialog
        :modal-append-to-body="false"
        :visible.sync="IMGdialogVisible"
        append-to-body
        center
        title="">
      <div v-if="IMGdialogVisible">
        <el-image :src="url"></el-image>
      </div>
    </el-dialog>
    <el-dialog
        :visible.sync="PDFdialogVisible"
        append-to-body
        fullscreen
        title="">
      <iframe :src="'/pdf/web/viewer.html?file='+ url" height="850px" type="application/pdf" width="100%"></iframe>
    </el-dialog>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {getdetailCommission, getListCommission, getRefundStatus, payTotal} from '@/api/biz/auction/winLot'
import AuctionStatusOptions from "@/enum/AuctionStatusOptions";
import {getToken} from "@/util/auth";
import {cmsDetail} from "@/api/biz/auction/auctionMeeting";
import {getDetailByCreateUser} from "@/api/biz/bankInfo";
import {getDepositeRecord} from "@/api/biz/auction/lotApply";
import {getDetail} from "@/api/biz/user/company"

export default {
  name: 'comMission',
  computed: {
    ...mapGetters(["userInfo"]),
    token() {
      return getToken();
    },
    settlementSummary() {
      const summary = [
        {name: '总代收成交标的金额', value: this.settlementForm.totalBidPrice},
        {name: '总代收评估费金额', value: this.settlementForm.totalEvaluationFee},
        {name: '过户(移交)保证金金额', value: this.settlementForm.totalHandoverDeposit},
        {name: '总佣金金额', value: this.settlementForm.totalCommission},
        {name: '应缴金额', value: this.settlementForm.totalPayment},
        {name: '减免金额', value: this.settlementForm.commissionReduction},
        {name: '实缴金额', value: this.settlementForm.totalFinalPayment},
        {name: '已缴金额', value: this.settlementForm.totalPaidMoney}
      ];

      // 处理待缴金额的特殊显示逻辑
      const totalUnpaidMoney = this.settlementForm.totalUnpaidMoney;
      if (totalUnpaidMoney !== undefined && totalUnpaidMoney !== null) {
        const unpaidValue = parseFloat(totalUnpaidMoney);
        summary.push({
          name: '待缴金额',
          value: unpaidValue,
          isNegative: unpaidValue < 0,
          displayValue: unpaidValue < 0
              ? `结余 ${Math.abs(unpaidValue).toFixed(2)}`
              : totalUnpaidMoney
        });
      } else {
        summary.push({name: '待缴金额', value: totalUnpaidMoney});
      }

      return summary;
    }
  },
  data() {
    return {
      activeNames: [],
      auditStatus: '',
      payType: '',
      meetingId: null,
      meetingDetail: {},
      bankInfo: {
        payAmount: '',
      },
      companyInfo: {},
      selectionList: [],
      currentRow: null,
      settlementData: [],
      isAllProcessed: false,
      dialogVisible: false,
      dialogTitle: "查看结算单",
      submitLoading: false,
      settlementForm: {
        meetingName: "",
        projects: [],
        totalBidPrice: 0,
        totalCommission: 0,
        commissionReduction: null,
        totalComputedCommission: 0
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      data: [],
      auctionStatusOptions: [],
      // 结算单
      form: {
        payType: 1,
      },
      // 缴纳
      payDialog: false,
      // 缴费记录表格
      tableData: [],
      commissionFile: {},
      payAmount: '',
      viewDialog: false,
      commissionList: [],
      PDFdialogVisible: false,
      IMGdialogVisible: false,
      // 地址
      url: '',
      //退款状态
      refundDialog: false,
      refundStatusData: [],
      refundDialogTitle: "退款状态详情"
    }
  },
  created() {
    if (getToken() && this.userInfo && this.userInfo.user_id) {
      this.init();
    } else {
      this.$router.push("/login")
    }
  },
  methods: {
    getPriceUnit(row) {
      return row.auctionWay === 1 ? '元' : `元/${row.unit}`;
    },
    formatPayCategory(payCategory) {
      const payCategoryMap = {
        1: '竞买保证金',
        2: '结算款'
      };
      return payCategoryMap[payCategory];
    },
    formatComType(comType) {
      const comTypeMap = {
        1: '固定比例',
        2: '区间比例',
        3: '固定金额'
      };
      return comTypeMap[comType] || '';
    },
    formatActualCommission(row) {
      const commission = row.commission;
      const derate = row.derate || 0;

      if (commission != null && derate != null) {
        return (parseFloat(commission) - parseFloat(derate)).toFixed(2);
      }
      return '';
    },
    // 文件预览
    uploadPreview(file) {
      let fileName = file.name;
      let index = fileName.lastIndexOf('.');
      let fileExten = fileName.substring(index + 1).toLowerCase();
      if (fileExten == 'pdf') {
        this.PDFdialogVisible = true;
        this.url = file.response.data.link;
      } else {
        this.IMGdialogVisible = true;
        this.url = file.response.data.link;
      }
    },
    handleDialogClose() {
      this.settlementForm = {
        meetingName: "",
        settlementNo: "",
        projects: [],
        commissionReduction: null,
      };
    },
    // 佣金凭证限制文件类型
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isPDF = file.type === 'application/pdf';

      if (!isJPG && !isPDF) {
        this.$message.error('只能上传jpg、png或pdf格式的文件');
        return false; // 阻止上传
      }
      return true; // 允许上传
    },
    // 佣金凭证删除
    comFileRemove() {
      this.commissionFile = null;
    },
    // 线下支付上传凭证
    handleCommissionSuccess(res) {
      this.commissionFile = res.data
    },
    // 提交缴费记录
    submitRecords(payType) {
      console.log('payType', payType)
      // 线上校验
      if (payType == 1) {
        this.form.payInfoList = this.tableData;
        this.form.payType = payType;
        if (this.form.payInfoList.length == 0) {
          return this.$message('请获取您的结算款缴费记录')
        }
        payTotal(this.form).then(() => {
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.onLoad(this.page);
          this.payDialog = false;
        })
      }
      // 线下校验
      if (payType == 2) {
        if (!this.bankInfo.payAmount) {
          return this.$message('请输入实际缴纳结算款金额')
        }
        this.form.commissionAttach = this.commissionFile;
        this.form.payAmount = this.bankInfo.payAmount;
        if (this.commissionFile == null || Object.keys(this.commissionFile).length === 0) {
          return this.$message('请您上传您的结算款缴费凭证')
        }
        payTotal(this.form).then(() => {
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.onLoad(this.page);
          this.payDialog = false;
        })
      }
    },
    previewCommissionFile(file) {
      const fileName = file.name;
      const index = fileName.lastIndexOf('.');
      const fileExten = fileName.substring(index + 1).toLowerCase();

      // 使用你传入的 url 字段
      const fileUrl = file.url;

      if (!fileUrl) {
        this.$message.error('文件地址不存在');
        return;
      }

      if (fileExten === 'pdf') {
        this.PDFdialogVisible = true;
        this.url = fileUrl;
      } else {
        this.IMGdialogVisible = true;
        this.url = fileUrl;
      }
    },
    // 获取佣金缴费记录
    getCommissionRecords() {
      let params = {
        meetingId: this.meetingId,
        bankAccount: this.companyInfo.bankAccount,
      }
      getDepositeRecord(params).then((res) => {
        const data = res.data.data;
        this.tableData = [];
        if (res.data.success && data.length !== 0) {
          data.forEach((item, index) => {
            // 格式化到账时间
            let tempTime = (item.trxdat ? (item.trxdat.substring(0, 4) + "-" + item.trxdat.substring(4, 6) + "-" + item.trxdat.substring(6, 8)) : new Date().toLocaleDateString().replaceAll('/', '-'))
                + " " + item.trxtim.substring(0, 2) + ":" + item.trxtim.substring(2, 4) + ":" + item.trxtim.substring(4, 6);
            let tableItem = {
              index: index,
              busino: item.trxnbr,
              personCoName: item.acName,
              payAccount: item.rpyacc,
              genterName: item.rpynam,
              genterAccount: (item.inbacc + item.dyanbr),
              payAmount: item.trxamt,
              accountTime: tempTime,
              trxset: item.trxset
            }
            this.tableData.push(tableItem);
          })
          this.$message.success('已获取到缴费记录，请核实无误后提交审核')
        } else {
          this.$message.warning('未查询到缴费记录')
        }
      })
    },
    // 初始化
    init() {
      this.auctionStatusOptions = AuctionStatusOptions;
      this.onLoad(this.page);
    },
    // 缴纳结算款
    pay(row) {
      this.meetingId = row.meetingId;
      this.settlementForm = {};
      this.payAmount = '';
      this.tableData = [];
      this.payDialog = true;
      this.auditStatus = row.auditStatus;
      cmsDetail(this.meetingId).then((res) => {
        this.meetingDetail = res.data.data;
        this.payType = this.meetingDetail.depositPayWay;

        // 获取结算单详情
        getdetailCommission(row.id).then((response) => {
          const data = response.data.data;
          this.settlementForm = data;
          this.form = {
            ...this.form,
            payType: this.payType,
            meetingStatementId: data.id,
            payAmount: this.payType == 2 ? this.bankInfo.payAmount : undefined
          };
        });

        // 获取银行和公司信息
        getDetailByCreateUser(this.meetingDetail.createUser).then(resp => {
          this.bankInfo = resp.data.data;
        });

        getDetail(this.meetingDetail.createUser).then(resp => {
          this.companyInfo = resp.data.data;
        });
      });
    },
    // 查看结算单
    view(row) {
      this.meetingId = row.meetingId;
      this.settlementForm = {};
      this.dialogVisible = true;
      getdetailCommission(row.id).then((res) => {
        this.settlementForm = res.data.data;
        this.activeNames = this.settlementForm.projects.map((item, index) => index);
        if (this.payType == 1) {
          this.tableData = res.data.data.payInfos;
        } else {
          this.form.commissionAttach
          this.commissionList.push({
            name: this.form.commissionAttach.originalName,
            url: this.form.commissionAttach.link
          })
          console.log("线下")
        }
      })
    },
    viewPay(row) {
      this.meetingId = row.meetingId;
      this.viewDialog = true;
      getdetailCommission(row.id).then((res) => {
        this.settlementForm = res.data.data;
        this.tableData = res.data.data.payInfos;
      })
    },
    // 查看退款状态
    viewRefundStatus(row) {
      // 需要导入 getRefundStatus 接口
      getRefundStatus(row.id).then(res => {
        if (res.data.success) {
          // 如果返回的是对象，根据实际结构提取数据
          const data = res.data.data;
          if (Array.isArray(data)) {
            this.refundStatusData = data;
          } else if (data) {
            // 假设对象有 crtAcc, crtNam, reqSts 等属性
            this.refundStatusData = [{
              crtAcc: data.crtAcc || '',
              crtNam: data.crtNam || '',
              reqSts: data.reqSts || ''
            }];
          } else {
            this.refundStatusData = [];
          }
          console.log('refundStatusData', this.refundStatusData);
          this.refundDialog = true;
        } else {
          this.$message.error(res.data.message || '获取退款状态失败');
          this.refundStatusData = [];
        }
      }).catch(() => {
        this.$message.error('获取退款状态失败');
        this.refundStatusData = [];
      });
    },
    //  格式化
    formatter(row, column, cellValue) {
      let child = this.auctionStatusOptions;
      for (var index in child) {
        if (child[index].key == cellValue) {
          return child[index].value;
        }
      }
      return ""
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.onLoad(this.page);
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.onLoad(this.page);
    },
    onLoad(page) {
      getListCommission(page.currentPage, page.pageSize).then(res => {
        const data = res.data.data;
        this.page.total = data.total;
        this.data = data.records;
        console.log('data', this.data)
      });
    }
  }
}
</script>

<style scoped>
.amount-positive {
  color: red; /* 红色表示需要缴纳的金额 */
}

.amount-negative {
  color: #67c23a; /* 绿色表示结余金额 */
}

.personbox {
  margin: 0 0 40px;
  display: none;
  background-color: #fff;
  display: block;
}

.personbox h2 {
  height: 30px;
  line-height: 30px;
  background: #e9e9e9;
  color: #424242;
  padding-left: 20px;
  font-size: 14px;
  font-weight: 400;
}

.sub-page {
  margin-top: 2%;
}

.block {
  margin-left: 50%;
  margin-bottom: 2%;
  margin-top: 2%;
}

.el-table--border {
  border: 1px solid #424242;
}

::v-deep .custom-dialog .el-dialog__header {
  background-color: #2196f3;
  padding: 16px 16px 10px;
}

::v-deep .custom-dialog .el-dialog__title {
  color: #fff;
  font-size: 16px;
}

::v-deep .custom-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

::v-deep .el-col {
  line-height: 3em;
}

.upload-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30vh; /* 可以根据需要设置高度 */
}

.value-display {
  display: inline-block;
  width: 80px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
